import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress'

//* SPINNER
export const Spinner = CircularProgress
export type SpinnerProps = CircularProgressProps
